export default __webpack_public_path__ + "static/media/26848751946a45c73186dfba4c3d2b9b.svg";